<page-toolbar title="Create Dashboard Message"></page-toolbar>

<page-content>
  <div class="field-group">
    <smart-input [(model)]="message" key="category"></smart-input>
    <smart-input [(model)]="message" key="readCondition"></smart-input>
  </div>

  <div *ngIf="!!message">
    <mat-tab-group (selectedTabChange)="tabChange($event)">
      <mat-tab *ngFor="let translation of message.translations" [label]="translation.lang"></mat-tab>
    </mat-tab-group>
    <ng-container *ngFor="let translation of message.translations; let i = index">
      <div *ngIf="selectedTabIndex === i" class="editor">
        <mat-form-field>
          <input [(ngModel)]="message.translations[i].title" matInput placeholder="Title">
        </mat-form-field>
        <editor
          (changeContent)="quillChanged($event, translation)"
          [content]="message.translations[i].message">
        </editor>
      </div>
    </ng-container>
  </div>

  <div class="button-right-container">
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>save</button>
  </div>

</page-content>

